import {Component, OnInit} from '@angular/core';
import {CoefService} from '../../service/coef.service';

@Component({
  selector: 'app-drawer-siple-lock',
  templateUrl: './drawer-siple-lock.component.html',
  styleUrls: ['./drawer-siple-lock.component.scss']
})
export class DrawerSipleLockComponent implements OnInit {

  constructor(public  coef: CoefService) {
  }

  ngOnInit() {
  }

}
